"use client"

import { Skeleton } from "@/components/ui/skeleton"

export const StoreInfoSkeleton = () => {
    return (
        <>
            {Array.from({ length: 2 }).map((_, idx) => (
                <div key={idx} className="flex flex-col sm:flex-row sm:gap-[30px] gap-4 py-[26px] border-t border-[#0000001a]">
                    <div className="w-full flex sm:flex-row flex-col sm:gap-5 gap-2 sm:w-[48.8%]">
                        <div className="sm:w-[55.5%] w-full relative sm:h-[326px] h-[228px] rounded-lg overflow-hidden">
                            <Skeleton className="w-full h-full" />
                        </div>
                        <div className="sm:w-[44.2%] w-full flex flex-col sm:gap-4 gap-2">
                            <Skeleton className="h-6 w-3/4" />

                            <div className="flex flex-col sm:gap-3 gap-1">
                                {Array.from({ length: 5 }).map((_, idx) => (
                                    <div key={idx} className="flex items-center gap-2">
                                        {idx < 3 && (
                                            <Skeleton className="w-[13px] h-[18px]" />
                                        )}
                                        <Skeleton className="h-4 flex-1" />
                                    </div>
                                ))}
                            </div>

                            <Skeleton className="h-9 w-fit px-[18px] rounded" />
                        </div>
                    </div>

                    <div className="w-full sm:w-[51.2%] flex sm:flex-row flex-col sm:p-2 sm:gap-0 gap-8">
                        <div className="w-full flex flex-col gap-3">
                            <Skeleton className="h-5 w-24" />

                            <div className="flex flex-col gap-1">
                                {Array.from({ length: 7 }).map((_, idx) => (
                                    <div key={idx} className="sm:w-[220px] w-full pt-1 pb-2 border-b border-[#0000001a] flex justify-between">
                                        <Skeleton className="h-4 w-16" />
                                        <Skeleton className="h-4 w-20" />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="w-full flex flex-col gap-4">
                            <Skeleton className="h-6 w-32" />

                            <div className="flex flex-col gap-3">
                                {Array.from({ length: 2 }).map((_, idx) => (
                                    <div key={idx} className="flex flex-col gap-4">
                                        <Skeleton className="h-4 w-20" />
                                        <Skeleton className="h-4 w-full" />
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}
